<template>
  <div>
    <h2>Facturen</h2>
    <div class="facturen">
      <div class="factuur" v-for="(f, i) in facturen" :key="i">
        <div class="factuurContent">
          <span class="price"><i class="fad fa-file-invoice"></i> €{{ f.bedragExBtw }}</span>
          <a :href="f.factuurUrl" target="_blank"><span>download</span></a>
          <span class="date"><i class="far fa-calendar"></i> {{ f.timestamp.toDate().toLocaleDateString() }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["facturen"]
}
</script>

<style lang="sass" scoped>
.factuur
  background-color: white
  padding: 10px
  margin-top: 10px
  border-radius: 5px
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)
  .factuurContent
    display: flex
    justify-content: space-between
</style>
